/**
 * DAĞITIM LİSTELERİ
 *
 * `tumpersonel@`, `mudurler@`, `zabita@` gibi adresler. Listeye gelen posta
 * bütün üyelere dağıtılır.
 *
 * Liste bir posta kutusu DEĞİLDİR: parolası yoktur, içine girilmez, yer
 * kaplamaz. Bu yüzden kutulardan ayrı bir ekranda duruyor — aynı listede
 * göstermek "bu adrese nasıl girerim" sorusunu doğururdu.
 */
import { useState, type FormEvent } from "react";
import { api, ApiHatasi } from "../api";
import { Bildirim, Durum, HataKutusu, Kart, Tablo, useCek } from "../ui";

export function Listeler() {
  const l = useCek(() => api.listeler(), []);
  const alanlar = useCek(() => api.alanadlari(), []);
  const [acik, setAcik] = useState<string | null>(null);
  const [hata, setHata] = useState<ApiHatasi | null>(null);
  const [bilgi, setBilgi] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  // yeni liste formu
  const [yeniAd, setYeniAd] = useState("");
  const [yeniAlan, setYeniAlan] = useState("");
  const [yeniAciklama, setYeniAciklama] = useState("");
  const [formAcik, setFormAcik] = useState(false);

  async function calistir(f: () => Promise<string>) {
    setHata(null);
    setBilgi(null);
    setBekliyor(true);
    try {
      setBilgi(await f());
      l.yenile();
    } catch (h) {
      setHata(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(false);
    }
  }

  async function listeAc(e: FormEvent) {
    e.preventDefault();
    await calistir(async () => {
      const y = await api.listeAc({
        ad: yeniAd.trim(),
        alanAdiId: yeniAlan,
        aciklama: yeniAciklama.trim() || undefined,
      });
      setYeniAd("");
      setYeniAciklama("");
      setFormAcik(false);
      return `${y.veri.eposta} listesi açıldı.`;
    });
  }

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Dağıtım listeleri</h1>
          <p>Tek adrese gelen posta, listedeki herkese dağıtılır.</p>
        </div>
        <div className="eylemler">
          <button className="dugme ana" onClick={() => setFormAcik((v) => !v)}>
            {formAcik ? "Vazgeç" : "Yeni liste"}
          </button>
        </div>
      </div>

      {hata && <HataKutusu hata={hata} />}
      {bilgi && <Bildirim tur="iyi">{bilgi}</Bildirim>}

      {formAcik && (
        <Kart baslik="Yeni dağıtım listesi">
          <form onSubmit={listeAc}>
            <label>
              Liste adı
              <input
                value={yeniAd}
                onChange={(e) => setYeniAd(e.target.value)}
                placeholder="tumpersonel"
                required
              />
            </label>
            <label>
              Alan adı
              <select value={yeniAlan} onChange={(e) => setYeniAlan(e.target.value)} required>
                <option value="">seçin…</option>
                {(alanlar.veri?.veri ?? []).map((a: any) => (
                  <option key={a.id} value={a.id}>
                    {a.name ?? a.ad}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Açıklama (isteğe bağlı)
              <input
                value={yeniAciklama}
                onChange={(e) => setYeniAciklama(e.target.value)}
                placeholder="Tüm personel duyuruları"
              />
            </label>
            <button type="submit" className="dugme ana" disabled={bekliyor || !yeniAd || !yeniAlan}>
              {bekliyor ? "Açılıyor…" : "Listeyi aç"}
            </button>
          </form>
        </Kart>
      )}

      {/*
        Zorlanamayan şey açıkça söylenir. Stalwart'ta "yalnızca kurum içi"
        diye bir liste ayarı yok; dışarıdan da yazılabiliyor. Bunu gizlemek,
        olmayan bir korumayı varmış gibi göstermek olurdu.
      */}
      <Bildirim tur="uyari">
        <strong>İç duyuru listelerinin adresini yayımlamayın.</strong> Posta
        sunucusu, liste adresine dışarıdan gelen postayı da kabul eder — tıpkı
        normal bir kutu gibi. Adresi bilmeyen yazamaz; bilen yazabilir ve bunu
        panelden engelleyemiyoruz.
      </Bildirim>

      <Durum cekim={l}>
        {(d) =>
          d.veri.length === 0 ? (
            <div className="bos">
              Henüz dağıtım listesi yok. <b>Yeni liste</b> ile açabilirsiniz.
            </div>
          ) : (
            <Kart baslik={`Listeler (${d.adet})`}>
              <Tablo basliklar={["Adres", "Açıklama", "Üye", ""]}>
                {d.veri.map((x) => (
                  <tr key={x.id}>
                    <td className="tek">{x.eposta}</td>
                    <td>{x.aciklama ?? "—"}</td>
                    <td>{x.uyeSayisi}</td>
                    <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                      <button
                        className="dugme kucuk"
                        onClick={() => setAcik(acik === x.id ? null : x.id)}
                      >
                        {acik === x.id ? "kapat" : "üyeler"}
                      </button>{" "}
                      <button
                        className="dugme kucuk tehlike"
                        disabled={bekliyor}
                        onClick={() => {
                          if (!window.confirm(`${x.eposta} listesi silinsin mi?\n\nÜye kutular silinmez; yalnızca liste adresi kaldırılır.`)) return;
                          void calistir(async () => (await api.listeSil(x.id)).mesaj);
                        }}
                      >
                        sil
                      </button>
                    </td>
                  </tr>
                ))}
              </Tablo>

              {acik && <Uyeler listeId={acik} yenile={() => l.yenile()} />}
            </Kart>
          )
        }
      </Durum>
    </>
  );
}

/** Bir listenin üyeleri — ayrı çekim, çünkü üye listesi ayrı uçta */
function Uyeler({ listeId, yenile }: { listeId: string; yenile: () => void }) {
  const d = useCek(() => api.liste(listeId), [listeId]);
  const kutular = useCek(() => api.kutular(), []);
  const [secili, setSecili] = useState("");
  const [hata, setHata] = useState<ApiHatasi | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  async function calistir(f: () => Promise<unknown>) {
    setHata(null);
    setBekliyor(true);
    try {
      await f();
      d.yenile();
      yenile();
      setSecili("");
    } catch (h) {
      setHata(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <div style={{ marginTop: 18 }}>
      {hata && <HataKutusu hata={hata} />}
      <Durum cekim={d}>
        {(y) => {
          const uyeKimlikleri = new Set(y.veri.uyeler.map((u) => u.hesapId));
          const eklenebilir = (kutular.veri?.veri ?? []).filter(
            (k: any) => !uyeKimlikleri.has(k.id),
          );
          return (
            <>
              <h3 style={{ marginTop: 0 }}>{y.veri.eposta} üyeleri</h3>

              {y.veri.uyeler.length === 0 ? (
                <div className="bos">
                  Bu listede henüz üye yok. Listeye gelen posta hiç kimseye ulaşmaz.
                </div>
              ) : (
                <Tablo basliklar={["Posta kutusu", ""]}>
                  {y.veri.uyeler.map((u) => (
                    <tr key={u.hesapId}>
                      <td className="tek">{u.eposta ?? u.hesapId}</td>
                      <td style={{ textAlign: "right" }}>
                        <button
                          className="dugme kucuk"
                          disabled={bekliyor}
                          onClick={() => calistir(() => api.listeUyeCikar(listeId, u.hesapId))}
                        >
                          çıkar
                        </button>
                      </td>
                    </tr>
                  ))}
                </Tablo>
              )}

              <div style={{ display: "flex", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
                <select
                  value={secili}
                  onChange={(e) => setSecili(e.target.value)}
                  style={{ flex: "1 1 240px", minWidth: 0 }}
                >
                  <option value="">kutu seçin…</option>
                  {eklenebilir.map((k: any) => (
                    <option key={k.id} value={k.id}>
                      {k.emailAddress ?? k.name}
                    </option>
                  ))}
                </select>
                <button
                  className="dugme ana"
                  disabled={bekliyor || !secili}
                  onClick={() => calistir(() => api.listeUyeEkle(listeId, secili))}
                >
                  Ekle
                </button>
              </div>
            </>
          );
        }}
      </Durum>
    </div>
  );
}
